// src/components/About.tsx
import { Leaf, Coffee, Award, Sprout } from 'lucide-react';

const About = () => {
  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <div className="mx-auto max-w-md text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-serif text-coffee-800 mb-4">Our Story</h2>
          <div className="w-16 h-1 bg-coffee-400 mx-auto mb-6"></div>
          <p className="text-coffee-600">
            From bean to cup, we're dedicated to creating the perfect coffee experience
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="rounded-lg overflow-hidden shadow-xl">
              <img 
                src="https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" 
                alt="Coffee beans being roasted" 
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="absolute -bottom-8 -right-8 bg-coffee-600 text-white p-6 rounded shadow-lg max-w-xs hidden md:block">
              <p className="font-serif italic">
                "Our passion for coffee drives us to excellence in every step of the process."
              </p>
              <p className="text-sm mt-2 text-coffee-200">— Maria Santos, Founder</p>
            </div>
          </div>

          <div>
            <h3 className="text-2xl md:text-3xl font-serif text-coffee-800 mb-4">
              Crafted with Care Since 2010
            </h3>
            <p className="text-coffee-700 mb-6">
              Moca began with a simple mission: to bring exceptional coffee to people who appreciate quality. 
              What started as a small roastery has grown into a beloved brand, but our commitment to 
              excellence has never wavered.
            </p>
            <p className="text-coffee-700 mb-8">
              We source our beans directly from sustainable farms around the world, 
              ensuring fair compensation for farmers and the highest quality product for our customers. 
              Each batch is carefully roasted to bring out its unique character and flavor profile.
            </p>
            
            <div className="grid grid-cols-2 gap-6">
              <FeatureCard 
                icon={<Leaf className="h-8 w-8 text-accent-mint" />}
                title="Sustainably Sourced"
                description="Direct trade relationships with farmers who share our values"
              />
              <FeatureCard 
                icon={<Coffee className="h-8 w-8 text-coffee-500" />}
                title="Expert Roasting"
                description="Small-batch roasting process overseen by certified specialists"
              />
              <FeatureCard 
                icon={<Award className="h-8 w-8 text-mocha-300" />}
                title="Award Winning"
                description="Recognized for exceptional quality and flavor profiles"
              />
              <FeatureCard 
                icon={<Sprout className="h-8 w-8 text-accent-mint" />}
                title="Eco-Friendly"
                description="Compostable packaging and carbon-neutral shipping"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const FeatureCard = ({ 
  icon, 
  title, 
  description 
}: { 
  icon: React.ReactNode; 
  title: string; 
  description: string 
}) => {
  return (
    <div className="p-4 rounded-lg bg-coffee-100 hover:bg-coffee-200 transition-colors">
      <div className="mb-3">
        {icon}
      </div>
      <h4 className="font-medium text-coffee-800 mb-1">{title}</h4>
      <p className="text-sm text-coffee-600">{description}</p>
    </div>
  );
};

export default About;